export default "__VITE_ASSET__UpK3UZHt__"